import Utils from './../../utils/Utils';
import logger from 'src/utils/logger/logger';
/**
 * Receive all ps4 notificacions here
 */
const __from_playstation_callback = (callbackData) => {
  try {
    PlaystationWebmaf.playstationCallback(callbackData);
  } catch (err) {
    logger.error('[PS4] Error ejecutando accessfunction:', err);
  }
};
window.accessfunction = __from_playstation_callback;
/**
 * Contains callbacks
 */
window.__playstation_callbacks = (window.__playstation_callbacks || {});

/**
 * Contains callbacks that are called once
 */
window.__playstation_callbacks_once = (window.__playstation_callbacks_once || {});


class PlaystationWebmaf {

  static playstationCallback(callbackData) {
    // No debe escapar una excepci\u00f3n hacia el bridge nativo o la app del PS4 muere
    try {
      if (Utils.isString(callbackData)) {
        callbackData = JSON.parse(callbackData);
      }

      if(!Utils.isUndefined(callbackData.command)) {
          if(callbackData.command === 'playerError') {
              logger.error('Error code, error code exa, error info> ', callbackData.error_code, callbackData.error_code_hexa, callbackData.error && callbackData.error.info);
          }
      }

      let callbacks;
      let callbacks_once;
      let i;

      if (callbackData && callbackData.command) {
        callbacks = window.__playstation_callbacks[callbackData.command];
        callbacks_once = window.__playstation_callbacks_once[callbackData.command];

        if (callbacks && callbacks.length > 0) {
            for (i = 0; i < callbacks.length; i++) {
              if(callbackData.command !== 'getPlaybackTime') {
                logger.debug("[PS4] Run callback of ", callbackData.command);
              }
              try {
                callbacks[i](callbackData);
              } catch (err) {
                logger.error(`[PS4] Error en callback de ${callbackData.command}:`, err);
              }
            }
        }

        if (callbacks_once && callbacks_once.length > 0) {
          for (i = 0; i < callbacks_once.length; i++) {
            if(callbackData.command !== 'getPlaybackTime') {
              logger.debug("[PS4] Run callback once of ", callbackData.command);
            }
            try {
              callbacks_once[i](callbackData);
            } catch (err) {
              logger.error(`[PS4] Error en callback once de ${callbackData.command}:`, err);
            }
          }
          delete window.__playstation_callbacks_once[callbackData.command];
        }
      }
    } catch (err) {
      logger.error('[PS4] Error procesando playstationCallback:', err);
    }
  }

  static sendCommand(commandName, args, callbackFunction, once) {
    try {
      let obj;
      let p;
      // Just in case...
      PlaystationWebmaf.addEventListener(commandName, callbackFunction, once);

      obj = {
        "command": commandName
      };
      if (args) {
        for (p in args) {
          obj[p] = args[p];
        }
      }
      if (window.external && window.external.user) {
        if(commandName !== 'getPlaybackTime') {
          //console.debug("[PS4] send the PS4 command" + JSON.stringify(obj));
        }
        window.external.user(JSON.stringify(obj));
      }
    } catch (err) {
      logger.error(`[PS4] Error enviando comando ${commandName}:`, err);
    }
  }

  static addEventListener(commandName, callbackFunction, once) {
    try {
      if(commandName !== 'getPlaybackTime') {
        logger.debug("[PS4] addEventListener of the command", commandName);
      }

      if (!callbackFunction || !Utils.isFunction(callbackFunction)) {
        if(commandName !== 'getPlaybackTime') {
          logger.debug("[PS4] no callback for the command, nothing to do", commandName);
        }
        return;
      }
      // All ps4 callbacks
      let callbackList;
      // Only callbacks for this commandName
      let callbacks;

      // Where to save listener?
      if (once) {
        callbackList = window.__playstation_callbacks_once;
      }
      else {
        callbackList = window.__playstation_callbacks;
      }
      logger.debug('[PS4] Pila de eventos en callbacks ANTES>' , callbackList);
      // Already exists?
      callbacks = callbackList[commandName];

      // First time this listener is setted, init in callbacks
      if (!callbacks) {
        callbacks = [];
        callbackList[commandName] = callbacks;
      }
      callbacks.push(callbackFunction);
    } catch (err) {
      logger.error(`[PS4] Error registrando callback de ${commandName}:`, err);
    }
  }

  static removeEventListener(commandName, callbackFunction) {
  try {
    logger.debug('[PS4] removeEventListener de ', commandName);

    if (window.__playstation_callbacks[commandName]) {
      window.__playstation_callbacks[commandName] = 
        window.__playstation_callbacks[commandName].filter(cb => cb !== callbackFunction);
    }

    if (window.__playstation_callbacks_once[commandName]) {
      window.__playstation_callbacks_once[commandName] = 
        window.__playstation_callbacks_once[commandName].filter(cb => cb !== callbackFunction);
    }
  } catch (err) {
    logger.error(`[PS4] Error removiendo callback de ${commandName}:`, err);
  }
  }
}

export default PlaystationWebmaf;


// WEBPACK FOOTER //
// ./src/devices/ps4/PlaystationWebmaf.js